module.exports = __webpack_public_path__ + "img/ASUS_Letter_new_2.0f1566e7.png";